import * as types from './types';

export const open = ({ componentIds }) => ({
  type: types.OPEN,
  payload: { componentIds },
});

export const close = () => ({
  type: types.CLOSE,
});
